import ShareOutlined from '@mui/icons-material/ShareOutlined';
import React, { useMemo, useState } from 'react';
import { toast } from 'react-toastify';
import { Draw } from '../../assets/Draw.tsx';
import { BiddingInput, BiddingView } from '../../graphql/types.gen';
import Arrow from '../../icons/Arrow.tsx';
import Repeat from '../../icons/Repeat.tsx';
import { IResult } from '../../pages/Game/Game.tsx';
import { Explanation } from '../Explanation/Explanation.tsx';
import { SequenceItem } from '../Sequence/SequenceItem.tsx';

const resultDictionary = {
	FULL: 'Dobrze',
	BAD: 'Źle',
	HALF: 'To dobra odpowiedź, ale są lepsze',
	MISSING_ALERT: 'Dobra odzywka, zły alert',
};

type AnswerProps = {
	result: IResult;
	bestAnswers: BiddingView[];
	userBid: BiddingInput;
	drawTest: () => void;
	repeatTest: () => void;
	nextTest?: () => void;
	forLesson?: boolean;
	comment?: string;
	currentTestId?: string;
};

const Answer = (props: AnswerProps) => {
	const { result, userBid, bestAnswers, drawTest, repeatTest, nextTest, forLesson, comment, currentTestId } = props;
	const [isRepeatDisabled, setIsRepeatDisabled] = useState(false);

	const text = useMemo(() => resultDictionary[result], [result]);

	const handleShareTest = () => {
		if (!currentTestId) return;

		const shareUrl = new URL(window.location.href);
		shareUrl.searchParams.set('testId', currentTestId);
		navigator.clipboard.writeText(shareUrl.toString());
		toast.success('Skopiowano link do testu');
	};

	return (
		<>
			<p className={`tested__result tested__result--${result}`}>{text}</p>
			<p className="tested__text tested__comment">{comment}</p>
			<div className="tested">
				<div>
					<p className="tested__text">TWOJA ODPOWIEDŹ</p>
					<SequenceItem item={userBid} classes="sequence-item-show sequence-item--explanation" />
				</div>

				{(result === 'BAD' || result === 'HALF' || result === 'MISSING_ALERT') && (
					<Explanation answers={bestAnswers} onShowCorrectAnswers={() => setIsRepeatDisabled(true)} />
				)}
			</div>
			<div className="tested__actions">
				{!forLesson && currentTestId && (
					<button
						className="button button__share button--ghost"
						onClick={handleShareTest}
						title="Skopiuj link do tego testu"
						aria-label="Skopiuj link do tego testu"
					>
						<ShareOutlined fontSize="small" />
					</button>
				)}
				{(result === 'BAD' || result === 'HALF') && !isRepeatDisabled && (
					<button className="button button__repeat" onClick={repeatTest}>
						Ponów <Repeat />
					</button>
				)}

				{nextTest && (
					<button className="button button__next" onClick={nextTest}>
						Kolejne <Arrow />
					</button>
				)}
				{!forLesson && (
					<button className="button button__draw" onClick={drawTest}>
						Losuj <Draw />
					</button>
				)}
			</div>
		</>
	);
};

export default Answer;
